export const PopupHeading = ({ title, subtitle, children }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-1">
      <h1 className="text-3xl font-bold text-center">{title}</h1>
      {subtitle && <p className="text-xl text-center normal-case">{subtitle}</p>}
      {children}
    </div>
  )
}